<span [class.hide-text]="isLoading">
  <ng-content />
</span>
@if (isLoading) {
  <div class="loading-spinner-wrapper">
    <mat-spinner [diameter]="24" />
  </div>
}
